(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Alumno', Alumno);

    Alumno.$inject = ['$resource'];

    function Alumno ($resource) {
        var resourceUrl =  'apo/clasesalumno/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getTipoNivel': {
         	   url:'apo/getTipoNivel',
         	   method: 'POST'
            },
            'getPlan': {
          	   url:'apo/getPlan',
          	   method: 'GET',
          	   isArray: true,
          	   transformResponse: function (data) {
          		   if (data) {
                     data = angular.fromJson(data);
          		   }
          		   return data;
          	   }
             },
             'getAlumno': {
            	   url:'apo/getAlumno',
            	   method: 'GET',
            	   isArray: false,
            	   transformResponse: function (data) {
            		   if (data) {
                       data = angular.fromJson(data);
            		   }
            		   return data;
            	   }
               }
        });
    }
})();
